import classNames from "classnames";
import { useTranslation } from "react-i18next";

import { GoalModel } from "@models";
import { setupForDark } from "@theme";

export default function GoalCardUsers({ goal }: { goal: GoalModel }) {
  const { t } = useTranslation();
  return (
    <div className={classNames(setupForDark("text-secondary"))}>
      {t("components.goalCardUsers.completedBy", { count: 4536 })}
    </div>
  );
}
